<script setup lang="ts">
import type { PostPropertyDisplayAttributes } from '@@/vuecomponents/SurfacePostProperties.vue'
const props = withDefaults(
  defineProps<{
    darkMode: boolean
    postProperty: PostPropertyDisplayAttributes
    propertyValueClass?: string
    as?: string
  }>(),
  {
    propertyValueClass: 'text-body-small',
    as: 'dd',
  },
)
</script>

<template>
  <component
    :is="as"
    :class="[
      'email-field-value',
      propertyValueClass,
      darkMode && 'text-light-text-100',
      !darkMode && 'text-dark-text-100',
    ]"
  >
    <a
      :href="`mailto:${props.postProperty.formattedValue}`"
      data-bridged-link="email"
      data-testid="surfacePostPropertiesEmailFieldValue"
      >{{ props.postProperty.formattedValue }}</a
    >
  </component>
</template>
<style scoped>
.email-field-value a {
  @apply underline;
  @apply text-current;
  text-underline-position: from-font;
  text-decoration-thickness: from-font;
}
</style>
